import { Divider, FlexLayout } from '@deity/falcon-ui';
import { PackagePopoutSkeleton } from 'components';
import DashboardBlocks from 'components/Packages/PackagePopout/DashboardBlocks';
import LatestVersionInfoLine from 'components/Packages/PackagePopout/LatestVersionInfoLine';
import PackageNameLine from 'components/Packages/PackagePopout/PackageNameLine';
import { CACHE_FIRST } from 'contracts/constants';
import type { FC } from 'react';
import { useEffect } from 'react';
import { useRouteMatch } from 'react-router-dom';
import {
  useGetPackageContentInfoQuery,
  useGetPackageVersionContentInfoLazyQuery,
  useGetPackageVersionQuery
} from 'services/graphql/generated/hooks';

type VersionDashboardProps = {
  uuid: string;
  name: string;
  modifiedAt: string;
};
export const PackagePopout: FC<VersionDashboardProps> = ({ name, uuid, modifiedAt }) => {
  const { url } = useRouteMatch();
  // const [getPackageVersion, { data: versionData }] = useGetPackageVersionLazyQuery(CACHE_FIRST);

  const [getPackageVersionContentInfo, { loading: loadingVersionContent, data: versionContentData }] =
    useGetPackageVersionContentInfoLazyQuery();

  const { loading: loadingContentInfo, data: packageContent } = useGetPackageContentInfoQuery({
    variables: { packageUuid: uuid }
  });
  const { data: versionData } = useGetPackageVersionQuery({
    variables: { uuid: packageContent?.getPackageContentInfo.latestVersion },
    skip: !packageContent?.getPackageContentInfo.latestVersion,
    ...CACHE_FIRST
  });

  useEffect(() => {
    const versionUuid = packageContent?.getPackageContentInfo.latestVersion;
    if (versionUuid) {
      // getPackageVersion({ variables: { uuid: versionUuid } });
      getPackageVersionContentInfo({ variables: { versionUuid } });
    }
  }, [packageContent]);

  const latestVersion = packageContent?.getPackageContentInfo?.latestVersion;
  const versionUrl = `${uuid}/${latestVersion}`;
  const baseUrl = `${url}/${versionUrl}`;

  return loadingVersionContent || loadingContentInfo ? (
    <PackagePopoutSkeleton />
  ) : (
    <FlexLayout flexDirection="column" width="full">
      <FlexLayout p="xl" flexDirection="column">
        <PackageNameLine packageName={name} baseUrl={baseUrl} />
        <LatestVersionInfoLine
          baseUrl={baseUrl}
          getPackageVersion={versionData?.getPackageVersion}
          packageContent={packageContent?.getPackageContentInfo}
          modifiedAt={modifiedAt}
        />
      </FlexLayout>
      <Divider css={{ borderColor: '#DADFE4' }} />
      <DashboardBlocks versionUrl={versionUrl} versionInfo={versionContentData?.getPackageVersionContentInfo} />
    </FlexLayout>
  );
};
